import API from "./API";

export default class SupplierEvaluation extends API
{
  static async search(filter) {
    return this.get("api/admin/supplier-evaluation", { params: filter });
  }

  static async list(filter) {
    return this.get("api/admin/supplier-evaluation/list", { params: filter });
  }

  static async find(id) {
    return this.get("api/admin/supplier-evaluation/" + id);
  }

  static async create(payload) {
    return this.post("api/admin/supplier-evaluation", payload);
  }

  static async update(payload, id) {
    return this.put("api/admin/supplier-evaluation/" + id, payload);
  }

  static async delete(id) {
    return this.deleteRequest("api/admin/supplier-evaluation/" + id);
  }

  static async exportEvaluations(filter) {
    return this.get("api/admin/supplier-evaluation/export", {params: filter});
  }

  static async checkAvailability(filter) {
    return this.get("api/admin/supplier-evaluation/check-availability", { params: filter });
  }
  
  static async getSupplierCentralCosts(filter) {
    return this.get("api/admin/supplier-evaluation/get-supplier-cc", { params: filter });
  }

  static async getCentralCosts(filter) {
    return this.get("api/admin/supplier-evaluation/get-central-costs", {params: filter});
  }
}
